var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundDetailsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2771_1074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 17C18.5 17.829 17.829 18.5 17 18.5C16.171 18.5 15.5 17.829 15.5 17C15.5 16.171 16.171 15.5 17 15.5C17.829 15.5 18.5 16.171 18.5 17ZM23.707 23.707C23.512 23.902 23.256 24 23 24C22.744 24 22.488 23.902 22.293 23.707L20.471 21.885C19.49 22.584 18.294 23 17 23C13.692 23 11 20.308 11 17C11 13.692 13.692 11 17 11C20.308 11 23 13.692 23 17C23 18.294 22.584 19.49 21.885 20.471L23.707 22.293C24.098 22.684 24.098 23.316 23.707 23.707ZM20.741 17.829C21.075 17.328 21.075 16.672 20.741 16.17C20.109 15.221 18.921 13.999 17 13.999C15.03 13.999 13.832 15.283 13.213 16.24C12.919 16.694 12.919 17.304 13.213 17.758C13.833 18.715 15.032 19.999 17 19.999C19.001 19.999 20.453 18.261 20.741 17.828V17.829ZM13 8H19.54C19.193 7.087 18.66 6.247 17.949 5.536L14.465 2.05C13.753 1.339 12.913 0.806 12 0.46V7C12 7.551 12.448 8 13 8ZM9 17C9 13.99 10.673 11.365 13.136 10H13C11.346 10 10 8.654 10 7V0.024C9.839 0.013 9.678 0 9.515 0H5C2.243 0 0 2.243 0 5V19C0 21.757 2.243 24 5 24H13.136C10.673 22.635 9 20.01 9 17Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2771_1074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundDetailsIcon);
export default __webpack_public_path__ + "static/media/round_details_icon.b2f9d5f45383dd2c7720f240e554031d.svg";
export { ForwardRef as ReactComponent };